import { FLAGS_COLOR_CODES } from '~constants'

/**
 * Maps dropdown / free-text input to the flag.color shape expected by the API.
 * Preset hex values use catalog names; any other non-empty string becomes a custom color.
 */
export const resolveFlagColorFromInput = input => {
  if (input == null) {
    return null
  }
  const trimmed = String(input).trim()
  if (!trimmed) {
    return null
  }
  const preset = FLAGS_COLOR_CODES.find(
    f => f.value === trimmed || f.value.toLowerCase() === trimmed.toLowerCase()
  )
  if (preset) {
    return { ...preset }
  }
  const value = trimmed.startsWith('#') ? trimmed : `#${trimmed}`
  return { name: trimmed, value }
}
